module.exports = __webpack_public_path__ + "img/fisumat-logo.5c503168.svg";